import { defineComponent as _defineComponent } from 'vue'
import PopOver from '@/components/common/PopOver.vue'
import { computed, onBeforeUnmount, onMounted, ref } from 'vue'
import mapboxgl from 'mapbox-gl'
import { useMap } from '../mapbox/context'
import { useRoute, useRouter } from 'vue-router/composables'
import { useStore } from 'vuex-composition-helpers'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewLocationMenu',
  setup(__props) {

const store = useStore()
const isAdmin = computed(() => store.getters['permissions/isAdmin'])
const contextMenuBounds = ref({ top: 0, left: 0, height: 0 })
const showContextMenu = ref(false)
const lastMapCoordinatesFromClick = ref<mapboxgl.LngLatLike>()

const { map } = useMap()
const router = useRouter()
const route = useRoute()

onMounted(() => {
  map.value?.on('contextmenu', handleOpenContextMenu)
  map.value?.on('dragstart', handleCloseContextMenu)
  map.value?.on('zoomstart', handleCloseContextMenu)
})

onBeforeUnmount(() => {
  map.value?.off('contextmenu', handleOpenContextMenu)
  map.value?.off('dragstart', handleCloseContextMenu)
  map.value?.off('zoomstart', handleCloseContextMenu)
})

const handleOpenContextMenu = (event) => {
  if (!isAdmin.value || route.name === 'fvnext-new-location') return
  showContextMenu.value = true
  contextMenuBounds.value.left = event.originalEvent.x
  contextMenuBounds.value.top = event.originalEvent.y

  lastMapCoordinatesFromClick.value = event.lngLat
}

const handleCloseContextMenu = () => {
  showContextMenu.value = false
}

const handleNewLocationClick = () => {
  if (route.name === 'fvnext-new-location') return
  router.push({
    name: 'fvnext-new-location',
    params: {
      defaultLat: (lastMapCoordinatesFromClick.value as any).lat,
      defaultLng: (lastMapCoordinatesFromClick.value as any).lng,
    },
  })

  // the animation of moving the map is less jarring with a small delay
  setTimeout(() => {
    map.value?.flyTo({
      center: lastMapCoordinatesFromClick.value,
    })
  }, 300)
}

return { __sfc: true,store, isAdmin, contextMenuBounds, showContextMenu, lastMapCoordinatesFromClick, map, router, route, handleOpenContextMenu, handleCloseContextMenu, handleNewLocationClick, PopOver }
}

})